import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, Icon } from 'antd'

const rowsFormat = (array, lastValue, delta) => {
  return [
    ...array
    //                UTC 0 to -5 Bogota Coloombia
      .map(e => [new Date(e[0] + delta), e[1]])
      .map(e => [e[0].toLocaleDateString(), e[1]])
      .map((e, i, arr) => ({
        key: e[0],
        date: e[0],
        value: e[1] || '---',
        status: i > 0 && e[i] !== null && arr[i - 1][1] !== null
          ? e[1] > arr[i - 1][1]
            ? <Icon style={{ color: '#a0d911' }} type='caret-up' />
            : e[1] < arr[i - 1][1]
              ? <Icon style={{ color: '#f5222d' }} type='caret-down' />
              : <font color='#bfbfbf'><b>=</b></font>
          : '---'
      })),
    {
      key: 'TODAY',
      date: <font color='#1890ff' ><b>TODAY</b></font>,
      value: lastValue
        ? <font color='#1890ff'><b>{lastValue}</b></font>
        : <Icon type='loading' />,
      status: <font color='#1890ff'><b>CURRENT</b></font>
    }
  ].reverse()
}

class FlowTable extends Component {
  render () {
    let { data, current, title, unit, delta } = this.props

    let columns = [{
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: '34%'
    }, {
      title: 'Value in ' + unit,
      dataIndex: 'value',
      key: 'value',
      align: 'center',
      width: '33%'
    }, {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '33%',
      align: 'center'
    }]

    return (
      <Table
        pagination={{ pageSize: this.props.pageSize || 10 }}
        size='small'
        title={() => (<center>{title}</center>)}
        columns={columns}
        dataSource={rowsFormat(data, current, delta)}
        sortOrder='descend'
      />
    )
  }
}

FlowTable.propTypes = {
  delta: PropTypes.number,
  data: PropTypes.array,
  current: PropTypes.number,
  pageSize: PropTypes.number,
  title: PropTypes.string,
  unit: PropTypes.string
}

export default FlowTable



// WEBPACK FOOTER //
// ./src/charts/FlowTable.js